import { MAX_STORY_LENGTH } from "../utils/MemoryExperience";
import styles from "../assets/styles/RandomDiversity2026Ticket.module.css";

export default function MemoryStoryFields({ story, onStoryChange, consent, onConsentChange, disabled = false }) {
  return <fieldset className={styles.storyFields} disabled={disabled}>
    <legend id="memory-story-label">사진에 남아 있는 이야기</legend>
    <p id="memory-story-hint">언제, 누구와 있던 순간인가요? 지금 이 사진을 보면 떠오르는 마음을 들려주세요. 쓰고 싶지 않은 내용은 적지 않아도 괜찮아요.</p>
    <textarea id="memory-story" value={story} onChange={event => onStoryChange(event.target.value)}
      maxLength={MAX_STORY_LENGTH} rows={6} required aria-labelledby="memory-story-label" aria-describedby="memory-story-hint memory-story-count"
      placeholder="그날 우리는 별것 아닌 일에도 오래 웃었습니다. 이 사진을 다시 보면…" />
    <span id="memory-story-count" className={styles.storyCount}>{story.length.toLocaleString()} / 4,000자</span>
    <label className={styles.consentLabel}>
      <input type="checkbox" checked={consent} onChange={event => onConsentChange(event.target.checked)} required aria-describedby="memory-privacy-notice memory-deletion-notice" />
      <span>사진과 이야기를 전시 체험에 활용하는 데 동의합니다.</span>
    </label>
    <p id="memory-privacy-notice" className={styles.storyPrivacy}>본인 또는 다른 사람의 민감한 개인정보는 적지 말아 주세요.</p>
    <p id="memory-deletion-notice" className={styles.storyPrivacy}>사진과 이야기 등 체험 데이터는 Random Diversity 앱에 티켓을 등록한 뒤, 티켓 상세의 ‘체험 데이터 삭제’에서 삭제할 수 있습니다.</p>
  </fieldset>;
}
